import { ClickEvent, Component, CrudDecorator, DecoratorRouter, Layout, SlideoutDecorator } from "@mcleod/components";
import { Alignment, Api, ArrayUtil, AuthToken, MenuItem, Navigation, StringUtil } from "@mcleod/core";
import { MainMenu } from "./MainMenu";
import { ImagingMenuLauncher } from "./ImagingMenuLauncher";

/**
 * This class is used to launch a page from the main menu.
 */
export class MenuLauncher {
    mainMenu: MainMenu;
    private imagingMenuLauncher = new ImagingMenuLauncher();

    constructor(mainMenu: MainMenu) {
        this.mainMenu = mainMenu;
    }

    openPageOnClick(item: MenuItem, openPageInSlideUp: boolean) {
        return (event: ClickEvent) => {
            if (openPageInSlideUp !== true)
                this.openPage(item, event.ctrlKey);
            else
                this.openPageInSlideUp(item);
        }
    }

    public async openPage(navItem: MenuItem, newTab: boolean, windowDecorators: boolean = false) {
        if (navItem == null) return;
        if (navItem.path == "url") {
            const window = await Navigation.navigateTo(this.replaceKeywords(navItem.params), { newTab: true });
            if (navItem.windowProperties != null) {
                window["mcleodProps"] = navItem.windowProperties;
            }
            if (navItem.messageProperties) {
                window.postMessage({ mcleodProps: navItem.messageProperties });
            }
        } else if (navItem.path == "dp-url" || navItem.path.includes("imaging/")) {
            this.imagingMenuLauncher.navigateTo(navItem, newTab, windowDecorators);
        } else if (navItem.caption === "Mpact.RatePro") {
            this.openMpactInBrowser();
        } else if (navItem.caption === "eLearning Portal") {
            this.openELearningPortalInBrowser();
        } else {
            Navigation.navigateTo(navItem.path || navItem[""], { newTab: newTab, windowDecorators: windowDecorators });
        }
        this.mainMenu.hide();
    }

    public async openPageInSlideUp(navItem: MenuItem) {
        this.mainMenu.hide();
        const layout = Layout.getLayout(navItem.path, { displayingFromToolbox: true });
        layout.addLayoutLoadListener(event => {
            const decorated: Component = DecoratorRouter.decoratePage(layout, null);
            if (decorated instanceof Layout) {
                new SlideoutDecorator({
                    layout: decorated,
                    title: navItem.caption,
                    transitionOptions: { direction: Alignment.BOTTOM },
                    displayOverlay: true,
                    overlayProps: { closeOnClickOff: false, coverPageHeader: false },
                    fillHorizontalSpace: true,
                    fillVerticalSpace: true
                });
            } else if (decorated instanceof CrudDecorator) {
                decorated.headerProps = { showClose: true };
                decorated.slideIn({ speed: 200 }, null, null, { paddingAll: 8 });
            } else
                throw new Error("This item cannot be opened from the menu as a slide up panel.")
        });
    }

    private replaceKeywords(input: string): string {
        return StringUtil.replaceAll(input, "{authToken}", AuthToken.get());
    }

    openMpactInBrowser() {
        Api.post("lme/dispatch/open-mpact-url").then((result) => {
            const apiData = result.data[0];
            if (apiData) {
                window.open(apiData.encrypted_url, "_blank");
            }
        });
    }

    private async openELearningPortalInBrowser() {
        const response = await Api.post("helplink/create-url", {});
        const data = ArrayUtil.getFirstElement(response?.data);
        if (data?.url != null) {
            Navigation.navigateTo(data.url, { newTab: true });
        }
    }
}
